module.exports = __webpack_public_path__ + "static/playing-games.b25c398a.jpg";